module.exports = __webpack_public_path__ + "static/media/abhee-nandana.5609afd0.png";